module.exports = __webpack_public_path__ + "static/media/hdb.5e6c40e8.png";